<template>
    <div class="main-layout">
        <Navbar :loginActive="false" :showLogout="false" />

        <div class="container is-fluid">
            <section class="section">
                <h2 class="title">{{ $t("signUp.title", {name: user.name, surname: user.surname}) }}</h2>

                <p>{{ $t("signUp.subtitle", {email: user.email}) }}</p>
                <br/>

                <div class="columns">
                    <div class="column is-3">
                        <div class="field">
                            <label class="label">{{ $t("misc.name") }}</label>
                            <div class="control">
                                <input class="input" v-model="user.name" type="text" :placeholder="$t('misc.namePlaceholder')">
                            </div>
                        </div>
                    </div>

                    <div class="column is-3">
                        <div class="field">
                            <label class="label">{{ $t('misc.surname') }}</label>
                            <div class="control">
                                <input class="input" v-model="user.surname" type="text" :placeholder="$t('misc.surnamePlaceholder')">
                            </div>
                        </div>
                    </div>

                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t('misc.password') }}</label>
                            <div class="control">
                                <input
                                    class="input"
                                    v-model="user.password"
                                    type="password"
                                    :placeholder="$t('misc.passwordPlaceholder')">
                            </div>
                        </div>

                        <FormIssues :errors="passwordValidationIssues" />
                    </div>
                </div>

                <p>{{ $t("signUp.wialonButtonDescription") }}</p>
                <br/>

                <b-button
                    @click="this.getAccessToken"
                    class="is-primary">
                    {{ $t("signUp.wialonButtonText") }}
                </b-button>

                <br/>
                <br/>

                <vue-recaptcha
                    :sitekey="recaptchaSiteKey"
                    @verify="recaptchaVerified">
                </vue-recaptcha>

                <hr/>

                <b-button
                    @click="completeSignUp"
                    class="is-primary">
                    {{ $t("misc.continue") }}
                </b-button>
            </section>
        </div>
    </div>
</template>

<script>

const axios = require('axios');
import shared from '@/utils.js';

import VueRecaptcha from 'vue-recaptcha';
import Navbar from "@/components/Navbar.vue";
import FormIssues from "@/components/FormIssues.vue";
import { EventBus, globalEvents } from '@/event-bus/event-bus.js';

export default {
    name: "SignUp",
    components: {
        Navbar,
        FormIssues,
        VueRecaptcha
    },
    data: function () {
        return {
            api: axios.create({
                baseURL: process.env.VUE_APP_JOBS_API_ROOT,
                headers: { Authorization: `Bearer ${localStorage.backendToken}` }
            }),
            user: {
                name: null,
                surname: null,
                password: null,
                wialonToken: null,
                username: null,
                email: null
            },
            passwordValidationIssues: [],
            recaptchaToken: null,
            recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
        }
    },
    methods: {
        getUser () {
            let view = this;

            this.api.get(`user-by-invitation/${this.$route.query.token}`).then(function (response) {
                view.user = response.data.user;
            }).catch(function () {
                view.$buefy.toast.open({
                    message: view.$t("signUp.invitationError"),
                    type: "is-danger"
                })
            })
        },
        getAccessToken () {
            shared.getAccessToken();
        },
        completeSignUp () {
            let view = this;

            if (this.user.name == null) {
                this.displayValidationError(this.$t("signUp.firstNameError"));
                return;
            }

            if (this.user.surname == null) {
                this.displayValidationError(this.$t("signUp.surnameError"));
                return;
            }

            if (this.user.password == null) {
                this.displayValidationError(this.$t("signUp.passwordError"));
                return;
            }

            if (this.user.wialonToken == null) {
                this.displayValidationError(this.$t("signUp.wialonError"));
                return;
            }

            if (this.recaptchaToken == null) {
                this.displayValidationError(this.$t("signUp.invalidReCAPTCHA"));
                return;
            }

            this.api.post(`complete-sign-up/${this.$route.query.token}`, this.user).then(function (response) {
                if (response.status == 200) {
                    view.$buefy.toast.open({
                        message: view.$t("signUp.registrationComplete"),
                        type: "is-success"
                    })

                    // Login the user and redirect to the dashboard
                    view.login(
                        view.user.email,
                        view.user.password,
                        view,
                        view.recaptchaToken
                    );
                } else {
                    view.displayRegistrationError();
                }
            }).catch(function (error) {
                if (error.response) {
                    if ("issues" in error.response.data) {
                        view.passwordValidationIssues = error.response.data.issues;
                    }
                } else {
                    view.displayRegistrationError();
                }
            })
        },
        displayValidationError (message) {
            this.$buefy.toast.open({
                message: message,
                type: "is-danger"
            })
        },
        displayRegistrationError () {
            this.$buefy.toast.open({
                message: this.$t("signUp.registrationError"),
                type: "is-danger"
            })
        },
        recaptchaVerified: function (response) {
            this.recaptchaToken = response;
        }
    },
    mounted: function () {
        if (localStorage.backendToken != null) {
            this.$router.push({
                name: "dashboard"
            });
        } else {
            this.getUser();
        }
    },
    created: function () {
        let view = this;

        this.login = shared.login;

        EventBus.$on(globalEvents.wialonTokenUpdated, (wialonToken) => {
            view.user.wialonToken = wialonToken;
        });
    }
};

</script>

<style scoped>
</style>